// @flow
import Container from './container'

export default (store) => ({
  path: '/login',
  element: <Container />,
})
